"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exchangeRateService = void 0;
const exchange_rate_service_1 = require("./exchange-rate-service");
const query_client_1 = require("../query-client");
exports.exchangeRateService = new exchange_rate_service_1.ExchangeRateService({
    resource: 'exchange-rate',
    parentResources: [],
    middleware: [],
    queryClient: query_client_1.queryClient,
});
